import { useUserInformation } from "../../../util/useUserInformation";
import ReactLogoDenmark from '../../../assets/denmark-flag-icon.svg';
import ReactLogoNorway from '../../../assets/norway-flag-icon.svg';
import ReactLogoNetherlands from '../../../assets/netherlands-flag-icon.svg';
import ReactLogoPoland from '../../../assets/poland-flag-icon.svg';
import ReactLogoSweden from '../../../assets/sweden-flag-icon.svg';
import ReactLogoSwitzerland from '../../../assets/switzerland-flag-icon.svg';
import ReactLogoGermany from '../../../assets/germany-flag-icon.svg';
import NoFlag from '../../../assets/no-flag.svg';

const useCountryFlag = () => {
  const { country } = useUserInformation();

  switch (country) {
    case 'DK':
      return ReactLogoDenmark;
    case 'DE':
      return ReactLogoGermany;
    case 'NO':
      return ReactLogoNorway;
    case 'NL':
      return ReactLogoNetherlands;
    case 'PL':
      return ReactLogoPoland;
    case 'SE':
      return ReactLogoSweden;
    case 'CH':
      return ReactLogoSwitzerland;
    default:
      return NoFlag;
  }
}

export default useCountryFlag;